<div class="ffl-warning-container">
    <img src="images/others/stop-sign.png" />
    <div class="ffl-popup">
        <span class="ffl-warning">WARNING!</span>
        <p>
          -- Sending a firearm to a non-FFL address is <u>prohibited</u> by federal law, any attempt to do so shall violate the terms of the sale and your sale shall be denied.
          <br><br>
          You may only ship to a FFL located in your state of residency.
          <br><br>
          FFL stands for Federal Firearms License. Firearms must be shipped to an FFL when purchased online.
          <br><br>
          Please <u>do not</u> use the 'Add FFL' option to add any address other than a legally registered FFL.
          <br><br>
          For more information please read our Privacy Policy and Terms of Service.
          <br><br>
        </p>
    </div>
    <p-button severity="danger" (click)="onCancelClick()">
        Cancel & Return Home
    </p-button>
    <p-button (click)="onAcceptClick()">
        I Acknowledge & Proceed
    </p-button>
</div>